import {
    Button,
    Typography
} from "@mui/material";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export type TProposedNewLocation = {
    readonly locationName: string;
    readonly useNewLocation: () => void;
    readonly returnToEditing: () => void;
}

export const ProposedNewLocation = ({ locationName, useNewLocation, returnToEditing }: TProposedNewLocation) => {
    return (
        <>
            <Typography variant={"h4"} color={"primary"}>
                {locationName}
            </Typography>
            <Button
                color="secondary"
                variant="contained"
                sx={{ maxHeight: "40px" }}
                startIcon={<ArrowBackIcon />}
                onClick={returnToEditing}
            >
                Return to Editing
            </Button>
            <Button
                sx={{ margin: (theme) => theme.spacing(2) }}
                variant="contained"
                onClick={useNewLocation}
            >
                Use New Location
            </Button>
        </>
    );
}